<template>

    <v-card>
            <v-card-title>Available Report Widgets</v-card-title>

            <v-divider></v-divider>

            <v-card-text>
                <div class="report-widgets-table-container">
                    <v-row>
                        <v-col cols="12">
                            <span class="report-widgets-table-label">Report Widgets</span>
                            <v-simple-table class="report-widgets-table" height="275px" fixed-header>
                                <thead>
                                    <tr>
                                        <th class="text-left">Name</th>
                                        <th class="text-left">Report</th>
                                        <th class="text-left">Owner</th>
                                        <th class="text-left">Private/Public</th>
                                        <th class="text-center"></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr style="cursor: pointer" v-for="reportWidget in $props.reportWidgets" :key="reportWidget.widget_name" @click="selectReportWidget(reportWidget)">
                                        <td>{{ reportWidget.widget_name }}</td>
                                        <td>{{ reportWidget.report_name }}</td>
                                        <td>{{ usernameLookup(reportWidget.user_id) }}</td>
                                        <td>
                                            <v-switch class="public-switch" color="#c42111" :ripple="true" v-model="reportWidget.widget_public" :disabled="reportWidget.user_id != $store.state.user.user_id" @click.native.capture.stop="publicClick(reportWidget)">
                                                <template v-slot:label>
                                                    <label>
                                                        {{ reportWidget.widget_public ? 'public' : 'private' }}
                                                    </label>
                                                </template>
                                            </v-switch>
                                        </td>
                                        <td>
                                            <v-btn icon color="#DC3545" :disabled="reportWidget.user_id != $store.state.user.user_id" @click.stop="deleteReportWidgetClick(reportWidget)"><v-icon la>mdi-delete-forever</v-icon></v-btn>
                                        </td>
                                    </tr>
                                </tbody>
                            </v-simple-table>
                        </v-col>

                    </v-row>
                </div>

                <v-divider class="mt-2 mb-4" />

                <span class="selected-report-widget-title">Selected Report Widget</span>
                <div class="report-widget-details-container">
                    <template v-if="selectedReportWidget">
                        <div class="report-widget-name">
                            <v-form ref="reportWidgetNameForm" v-model="reportWidgetNameFormValid" :lazy-validation="true">
                                <v-text-field v-model="selectedReportWidgetClone.widget_name" label="Report Widget Name" color="#c42111" :disabled="!userOwnsSelectedView" :rules="[validation.required(selectedReportWidgetClone.widget_name, 'Report Widget Name'), validation.unique(selectedReportWidgetClone.widget_name, $props.reportWidgets, $store.state.user.user_id)]">
                                    <template v-slot:append>
                                        <v-btn color="#4caf50" icon @click="saveReportWidgetNameClick"><v-icon>mdi-content-save</v-icon></v-btn>
                                    </template>
                                </v-text-field>
                            </v-form>
                        </div>
                        <div class="report-widget-params">
                            <span class="params-title">Report Parameters</span>
                            <div>
                                <!-- <span class="params-value" v-text="formatParams(selectedReportWidget.human_params)"></span> -->
                                <template v-for="(param, index) in selectedReportWidget.report_params">
                                    <span class="params-value" v-text="param.humanText"></span>
                                    <span v-if="index != (selectedReportWidget.report_params.length - 1)" class="seperator">•</span>
                                </template>
                            </div>
                        </div>
                        <div class="add-report-widget">
                            <v-btn color="#c42111" @click="addReportWidget">Add</v-btn>
                        </div>
                    </template>
                    <div v-if="!selectedReportWidget">
                        <span class="no-report-widget-selected-text">Select a Report Widget</span>
                    </div>
                </div>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
                <div class="flex-grow-1"></div>
                <v-btn text @click="$emit('close')">Close</v-btn>
            </v-card-actions>

    </v-card>
    
</template>

<script>
export default {
    name: 'ReportWidgetList',
    props: ['reportWidgets'],
    components: {

    },
    data: () => ({
        reportWidgetNameFormValid: true,
        selectedReportWidget: null,
        selectedReportWidgetClone: null,
        validation: {
            required: (value, fieldName) => ((value || value === 0) ? true : false) || `${fieldName} is required`,
            unique: (widgetName, reportWidgets, userId) => (!widgetName || !reportWidgets.some(rw => {return (rw.user_id == userId && rw.widget_name == widgetName.trim())})) || 'This Report Widget Name is already is use for this user.'
        }
    }),

    computed: {
        userOwnsSelectedView: function() {
            if(!this.selectedReportWidget) {
                return false;
            }
            return this.selectedReportWidget.user_id == this.$store.state.user.user_id;
        },

    },

    methods: {
        selectReportWidget: function(reportWidget) {
            this.selectedReportWidget = reportWidget;
            this.selectedReportWidgetClone = JSON.parse(JSON.stringify(reportWidget));
        },

        publicClick: function(reportWidget) {
            // Warn them if they are making a public view private.
            if(reportWidget.widget_public) {
                this.$store.commit('showConfirmModal', {
                    title: 'Confirm Overwrite',
                    message: `Making this report widget private will prevent other users from adding it to a dashboard. If they already have it in a dashboard they will continue to be able to use it. Are you sure you want to do this?`,
                    type: 'warning',
                    hideCancel: false,
                    confirmAction: () => {reportWidget.widget_public = false; this.saveReportWidget(reportWidget, reportWidget.widget_name);}
                });
            }
            else {
                reportWidget.widget_public = true;
                this.saveReportWidget(reportWidget, reportWidget.widget_name);
            }
        },

        saveReportWidget: function(reportWidget, oldWidgetName) {
            TELSA.loading(true);
            let route = `${TELSA.apiHost}report/widgets/edit`;
            return this.$http.post(route, {args: {reportWidget: reportWidget, old_widget_name: oldWidgetName}}).then(response => {
                let result = response.body;
                TELSA.loading(false);
            });
        },

        usernameLookup: function(userId) {
            for(let user of this.$store.state.batchConfig.users) {
                if(user.user_id == userId) {
                    return user.user_username;
                }
            }
            return '';
        },

        saveReportWidgetNameClick: function() {
            if(this.$refs.reportWidgetNameForm.validate()) {
                this.$store.commit('showConfirmModal', {
                    title: 'Confirm Overwrite',
                    //message: `Renaming this view will prevent other users from continuing to use it. Are you sure you want to do this?`,
                    message: `Are you sure you want to rename this report widget?`,
                    type: 'warning',
                    hideCancel: false,
                    confirmAction: () => {this.saveReportWidget(this.selectedReportWidgetClone, this.selectedReportWidget.widget_name); this.selectedReportWidget.widget_name = this.selectedReportWidgetClone.widget_name;}
                });
            }
        },

        // formatParams: function() {
        //     return this.selectedReportWidget.human_params.join('•');
        // },

        deleteReportWidgetClick: function(reportWidget) {
            this.$store.commit('showConfirmModal', {
                title: 'Confirm Delete',
                message: `Deleteing this report widget will prevent other users from adding it to a dashboard. If they already have it in a dashboard they will continue to be able to use it. Are you sure you want to do this?`,
                type: 'delete',
                hideCancel: false,
                confirmAction: () => this.deleteReportWidget(reportWidget)
            });
        },
        deleteReportWidget: function(reportWidget) {
            TELSA.loading(true);
            let route = `${TELSA.apiHost}report/widgets/delete`;
            return this.$http.post(route, {args: {reportWidget: reportWidget}}).then(response => {
                let result = response.body;
                this.$props.reportWidgets.splice(this.$props.reportWidgets.indexOf(reportWidget), 1);
                TELSA.loading(false);
            });
        },

        addReportWidget: function() {
            this.$emit('add', this.selectedReportWidget);
        }

    },

    mounted() {
    }

  
};
</script>

<style scoped>

    .report-widgets-table-container {
        margin-top: 1em;
    }

    .report-widgets-table-label {
        display: block;
        color: #ffffff;
        font-size: 18px;
        margin-bottom: 0.5em;
    }

    .report-widgets-table {
        border-radius: 5px;
        border: gray solid 1px;
        overflow-y: auto;
    }

    .public-switch {
        margin: 0px !important;
        padding: 0px !important;
        height: 25px;
    }

    .selected-report-widget-title {
        display: block;
        color: #ffffff;
        font-size: 18px;
    }

    .report-widget-details-container {
        position: relative;
        margin-top: 1em;
        border-radius: 5px;
        border: gray solid 1px;
        height: 125px;
        padding-top: 20px;
        padding-left: 20px;
    }

    .report-widget-name {
        display: inline-block;
        margin-right: 40px;
        width: 350px;
        vertical-align: top;
        position: relative;
    }

    .report-widget-params {
        display: inline-block;
        position: relative;
        width: calc(100% - 485px);
        margin-top: 3px;
    }

    .report-widget-params .params-title {
        display: block;
        text-decoration: underline;
        position: relative;
    }
    .report-widget-params .params-value {
        display: inline-block;
        position: relative;
        color: #ffffff;
        font-weight: bold;
    }
    .report-widget-params .seperator {
        margin-left: 10px;
        margin-right: 10px;
        font-weight: bold;
    }

    .no-report-widget-selected-text {
        margin-top: 20px;
        font-size: 32px;
        text-align: center;
        color: rgba(255, 255, 255, 0.5);
        display: block;
        margin-left: -40px;
    }

    .add-report-widget {
        display: inline-block;
        margin-left: 10px;
        vertical-align: top;
        margin-top: 25px;
    }

</style>
